// @ts-nocheck
// Requires three services added in Usercentrics Admin:
//   "Shopify Analytics", "Shopify Marketing", "Shopify Preferences"
// Docs: https://support.usercentrics.com/hc/en-us/articles/21694498850716
(function () {
  function getShopifyConsents() {
    try {
      if (!window.UC_UI || typeof window.UC_UI.getServicesBaseInfo !== 'function') return null;

      var services = window.UC_UI.getServicesBaseInfo();
      var result = { analytics: null, marketing: null, preferences: null };
      var found = false;

      for (var i = 0; i < services.length; i++) {
        var name = services[i].name;
        var consented = services[i].consent.status === true;
        if (name === 'Shopify Analytics') {
          result.analytics = consented;
          found = true;
        } else if (name === 'Shopify Marketing') {
          result.marketing = consented;
          found = true;
        } else if (name === 'Shopify Preferences') {
          result.preferences = consented;
          found = true;
        }
      }

      return found ? result : null;
    } catch (e) {
      return null;
    }
  }

  function syncToShopify() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return;

    var consents = getShopifyConsents();
    if (!consents) return;

    window.Shopify.customerPrivacy.setTrackingConsent({
      marketing: consents.marketing === true,
      analytics: consents.analytics === true,
      preferences: consents.preferences === true,
      sale_of_data: false,
    });
  }

  window.addEventListener('UC_UI_INITIALIZED', syncToShopify);

  window.addEventListener('UC_UI_CMP_EVENT', function (e) {
    var type = e.detail && e.detail.type;
    if (type === 'ACCEPT_ALL' || type === 'DENY_ALL' || type === 'SAVE') {
      syncToShopify();
    }
  });

  if (window.UC_UI && typeof window.UC_UI.isInitialized === 'function' && window.UC_UI.isInitialized()) {
    syncToShopify();
  }
})();
